import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { concatMap, EMPTY, map, of, Subscription, type Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
import { StorageEnum } from '../../shared/enums/storage.enum';
import { PaymentAccountType } from '../../shared/enums/paymentaccounttype.enum';
import { AccountDetail } from '../../shared/models/account-detail';
import { RateType } from '../../shared/enums/ratetype.enum';
import { CreditPipe } from '../../shared/pipes/credit.pipe';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentService } from '../../shared/services/payment.service';
import {
  addDays,
  differenceInCalendarDays,
  format,
  isAfter,
  isBefore,
  isWithinInterval,
  subDays,
  toDate,
} from 'date-fns';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { type UserProfile } from '../../shared/models/user-profile';
import { HeadlineEnum } from '../../shared/enums/headline.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PlanService } from '../../shared/services/plan.service';
import { BillingSettingsComponent } from '../../shared/components/billing-settings/billing-settings.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PerThermPipe } from '../../shared/pipes/per-therm.pipe';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';
import { CustomerClassEnum } from '../../shared/enums/customerclass.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PreviousRouteService } from '../../shared/services/previous-route.service';
import { Nav } from '../../shared/enums/nav.enum';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { type BannerAd } from '../../shared/models/banner-ad';

@Component({
  selector: 'app-account-summary',
  providers: [CurrencyPipe, DatePipe, PerThermPipe],
  imports: [
    MatButtonModule,
    MatCardModule,
    MatExpansionModule,
    MatDividerModule,
    DatePipe,
    CurrencyPipe,
    CommonModule,
    CreditPipe,
    MatFormFieldModule,
    MatSelectModule,
    BillingSettingsComponent,
    MatTooltipModule,
    PageHeaderComponent,
    RouterModule,
    NotificationComponent,
  ],
  templateUrl: './account-summary.component.html',
  styleUrl: './account-summary.component.scss',
})
export class AccountSummaryComponent implements OnInit {
  panelOpenState = false;
  blogs$!: Observable<any>;
  env = environment;
  isMobile = false;
  account$!: Subscription;
  isBrowser = false;
  pageReady = false;
  accountDetail: AccountDetail = new AccountDetail();
  pageLabels: any = {};
  pageData: any = {};
  pageName = Nav.AccountSummary;
  dueDateDifference: number | undefined;
  PaymentAccountType = PaymentAccountType;
  viewBill: boolean = false;
  loginRes: UserProfile = this.storage.getSession(StorageEnum.LoginResponse);
  multiRes: UserProfile = this.storage.getSession(StorageEnum.MultiAccountResponse);
  pageHeader = new PageHeader();
  showFinalBillText: boolean = false;
  showExpirationDate: boolean = true;
  hasFuturePayment: boolean = false;
  billSettingsData: any = {
    showWallet: false,
  };

  oppTag: string = '';
  multiAccount = this.storage.getSession(StorageEnum.MultiAccountResponse);
  featureTiles: any[] = [];
  notification = '';
  bannerAd: BannerAd | null = null;
  showBannerAd = false;

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly utils: UtilService,
    private readonly cms: CmsService,
    private readonly router: Router,
    private readonly acct: AccountService,
    private readonly payment: PaymentService,
    private readonly storage: StorageService,
    private readonly plan: PlanService,
    private readonly currencyP: CurrencyPipe,
    private readonly dateP: DatePipe,
    private readonly perThermPipe: PerThermPipe,
    private readonly seoS: SeoService,
    private readonly prev: PreviousRouteService,
    private readonly notifi: NotificationsService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.getAccountData();
    if (this.isBrowser) {
      this.isMobile = this.utils.isMobile(992);
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', () => {
          this.isMobile = this.utils.isMobile(992);
        });
      }
    }
  }

  getBlogs(useResidentialCategoryFilter: boolean): Observable<any> {
    return this.cms.getBlogs(3, useResidentialCategoryFilter);
  }

  formatBlogDate(dateString: string): string {
    const d = new Date(dateString);
    const dMonth = d.getMonth() + 1;
    const dDay = d.getDate();
    const dYear = d.getFullYear();

    return dMonth.toString() + '/' + dDay.toString() + '/' + dYear.toString();
  }

  async navToPayment(): Promise<void> {
    this.utils.showSpinner();
    await this.router.navigate(['/payment']);
  }

  async navToCancelFuturePayment(): Promise<void> {
    this.utils.showSpinner();
    await this.router.navigate(['/cancel-future-payment']);
  }

  async navToWallet(): Promise<void> {
    this.utils.showSpinner();
    await this.router.navigate(['/billing-and-payments/wallet']);
  }

  onFeatureTileClick(): void {
    this.utils.showSpinner();
  }

  getAccountData(): void {
    if (this.isBrowser) {
      this.oppTag = this.storage.getSession(StorageEnum.GlobalVars).oppTag;
    }

    let acct: any;
    let accountNumber: any;

    this.getPageLabels()
      .pipe(
        concatMap((data) => {
          this.pageLabels = data;
          this.setBannerAd(this.pageLabels);

          if (this.isBrowser) {
            acct = this.storage.getSession(StorageEnum.LoginResponse);
            accountNumber = acct?.Accounts[0]?.AccountNumber;
            if (!this.prev.getPreviousUrl().includes(Nav.MultiAccountSummary)) {
              return this.acct.getAccountDetail(accountNumber, acct.UserName);
            } else {
              this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
              return of('account found in storage');
            }
          } else {
            return EMPTY;
          }
        }),
        concatMap((data: any) => {
          if (data === 'account found in storage') {
            return of('account found in storage');
          }
          this.accountDetail = data;
          return this.payment.GetFuturePayment(accountNumber);
        }),
        concatMap((data: any) => {
          if (data === 'account found in storage') {
            return of('account found in storage');
          }
          this.accountDetail.FuturePayment = data;

          if (this.loginRes?.Accounts[0].ServiceAddresses[0].SaStatusFlag === '10') {
            // if SaStatusCode = Pending Start - set headline to 10 = Pending Start,
            return of('10');
          } else {
            return this.acct.GetHeadlineCode(accountNumber);
          }
        }),
        concatMap((data: string) => {
          if (data === 'account found in storage') {
            return of('account found in storage');
          }
          this.accountDetail.HeadlineCode = this.utils.isNullOrUndefined(data) ? data : data.toString();
          if (this.accountDetail.IsAutoPay) {
            return this.acct.GetAutoPayDetails(accountNumber);
          } else {
            return of('no autopay');
          }
        }),
        concatMap((data: any) => {
          if (data === 'account found in storage') {
            return of('account found in storage');
          }
          if (data !== 'no autopay') {
            this.accountDetail.AutoPay = data;
          }

          if (this.accountDetail.IsPayPlan) {
            return this.acct.GetPayPlanDetails(accountNumber);
          } else {
            return of('no payplan');
          }
        }),
        concatMap((data: any) => {
          if (data === 'account found in storage') {
            return of('account found in storage');
          }
          if (data !== 'no payplan') {
            this.accountDetail.PayPlanAmount = data.PayPlanAmount;
            this.accountDetail.PayPlanDueDate = data.PayPlanDueDate;
            this.accountDetail.PayPlanType = data.PayPlanType;
            this.accountDetail.PaymentPlans = data.PaymentPlans;
          }
          const personReq = {
            AccountNumber: accountNumber,
            UserName: this.accountDetail.PrimaryAccountHolder === true ? acct.UserName : '',
            PersonId: acct.PersonId,
          };
          return this.acct.GetPerson(personReq);
        }),
        concatMap((personData: any) => {
          if (personData === 'account found in storage') {
            return of('account found in storage');
          }
          if (this.isBrowser) {
            personData.FirstName = this.accountDetail.FirstName;
            personData.LastName = this.accountDetail.LastName;
            this.accountDetail.Person = personData;
            this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
            this.storage.setSession(StorageEnum.SelectedSA, this.accountDetail.ServiceAddresses[0]);
            return of('person set');
          } else {
            return of({});
          }
        }),
        concatMap((data: any) => {
          if (data === 'person set') {
            return this.payment.getPreferredPayments(this.accountDetail);
          } else {
            return of('no preferred payment');
          }
        }),
      )
      .subscribe((preferredPayment: any) => {
        const useResidentialCategoryFilter = this.accountDetail.CustomerClass === CustomerClassEnum.RES;
        this.blogs$ = this.getBlogs(useResidentialCategoryFilter);

        this.dueDateDifference = this.differenceInDates(this.accountDetail);
        this.viewBill = this.checkIsFourDayPrior();
        this.checkForFutureDatedPayment();
        this.plan.setPerThermPipe(this.perThermPipe);
        this.setPageData();
        this.checkRateChangeEligibility();
        this.checkRenewEligibility();
        this.setHeadline();
        if (!this.utils.isNullOrUndefined(preferredPayment) && preferredPayment !== 'no preferred payment') {
          if (preferredPayment.PaymentMethods?.length > 0) {
            this.billSettingsData.showWallet = true;
            this.billSettingsData = JSON.parse(JSON.stringify(this.billSettingsData));
          }
        }
        if (!this.utils.isNullOrUndefined(this.pageLabels) && !this.utils.isNullOrUndefined(this.pageData)) {
          this.pageLabels.billingSettings = this.cms.flattenBuilderReferencesPreservingKeys(
            this.pageLabels.billingSettings,
          );
          this.billSettingsData.billingSettings = this.pageLabels.billingSettings;
          this.billSettingsData.header = this.pageLabels.billingSettingsHeader;
          this.setFeatureTilesToShow(this.pageLabels);
          this.utils.rateChangeOrUpdate.set(false);
          this.utils.updateNav.set(true);
          this.pageReady = true;
          this.utils.hideSpinner();
        }
      });
  }

  checkForFutureDatedPayment(): void {
    if (
      !this.utils.isNullOrUndefined(this.accountDetail.FuturePayment) &&
      this.accountDetail.FuturePayment?.Info?.PaymentDate !== undefined &&
      this.accountDetail.CurrentBalanceDueDate !== undefined
    ) {
      if (!this.accountDetail.IsAutoPay) {
        if (isAfter(this.accountDetail.FuturePayment?.Info?.PaymentDate, new Date())) {
          this.hasFuturePayment = true;
        }
      } else if (this.accountDetail.IsAutoPay) {
        if (
          isAfter(this.accountDetail.FuturePayment?.Info?.PaymentDate, new Date()) &&
          isBefore(this.accountDetail.FuturePayment?.Info?.PaymentDate, this.accountDetail.CurrentBalanceDueDate)
        ) {
          this.hasFuturePayment = true;
        }
      }
    }
  }

  setHeadline(): void {
    this.pageHeader.IsHeadline = true;
    const headlineList = this.pageLabels.headlineList.value.data.headlineList;

    let headlineRecord = headlineList.find((labels: any) => {
      return labels.headlineCode === this.accountDetail.HeadlineCode;
    });

    if (
      this.accountDetail.HeadlineCode === '55' &&
      (this.accountDetail.SaRateScheduleCode?.includes('NMX') ??
        this.accountDetail.SaRateScheduleCode?.includes('MEX') ??
        this.accountDetail.SaRateScheduleCode?.includes('IND') ??
        this.accountDetail.SaRateScheduleCode?.includes('IX')) &&
      !this.accountDetail.SaRateScheduleCode?.includes('FIX')
    ) {
      // get Message for Headline 55 NYMEX
      headlineRecord = headlineList.find((labels: any) => {
        return labels.headlineCode === '55NYMEX';
      });
    }
    if (this.accountDetail.HeadlineCode === HeadlineEnum.ClosedButWithinSameSession) {
      const inInterval = isWithinInterval(new Date(this.loginRes?.Accounts[0].ServiceAddresses[0].SaEndDate ?? ''), {
        start: subDays(new Date(), 90),
        end: new Date(),
      });
      if (!inInterval) {
        headlineRecord = headlineList.find((labels: any) => {
          return labels.headlineCode === HeadlineEnum.ClosedNotSeasonalResSMComNoReconnect;
        });
      } else {
        if (this.accountDetail.CustomerClass === CustomerClassEnum.LRGCOM) {
          headlineRecord = headlineList.find((labels: any) => {
            return labels.headlineCode === HeadlineEnum.ClosedNotSeasonalLargeCom;
          });
        }
      }
    }
    if (this.accountDetail.HeadlineCode === '50') {
      const collectionsNotification = this.pageLabels.collectionsWarningText.replace(
        '{{MinimumPaymentDue}}',
        this.currencyP.transform(this.accountDetail.MinimumPayment),
      );
      this.notifi.addNotification(collectionsNotification, NotificationType.Warning, this.pageName);
    }
    if (!headlineRecord) {
      // get Default Headline - code = 0
      headlineRecord = headlineList.find((labels: any) => {
        return labels.headlineCode === HeadlineEnum.Default;
      });
    }

    let firstName = this.accountDetail.FirstName;
    if (!firstName) {
      firstName = this.accountDetail.LastName;
    }
    this.pageHeader.Message = headlineRecord.headlineMessage
      .replace('{{ FirstName }}', firstName)
      .replace('{{ SaStartDate }}', this.dateP.transform(this.accountDetail.ServiceStartDate, 'MM/dd/yyyy'))
      .replace('{{ PastDueBalance }}', this.currencyP.transform(this.accountDetail.PastDueBalance))
      .replace('{{ Today }}', this.dateP.transform(new Date().toString(), 'MM/dd/yyyy'))
      .replace(
        '{{ PlanExpirationDate }}',
        this.dateP.transform(this.accountDetail.BillingRateExpirationDate, 'MM/dd/yyyy'),
      )
      .replace('{{ AccountBalance }}', this.currencyP.transform(this.accountDetail.CurrentBalance))
      .replace('{{ BillDueDate }}', this.dateP.transform(this.accountDetail.CurrentBalanceDueDate), 'MM/dd/yyyy');

    let showHeadlineButton = true;
    if (this.accountDetail.HeadlineCode === HeadlineEnum.IsZeroCredBal && this.accountDetail.IsAutoPay) {
      showHeadlineButton = false;
    }
    if (headlineRecord.ctaLink && showHeadlineButton) {
      this.pageHeader.RedirectURL = headlineRecord.ctaLink.value.data.url;
      this.pageHeader.ButtonLabel = headlineRecord.ctaLink.value.data.linkText;
      this.pageHeader.ButtonAriaLabel = headlineRecord.ctaLink.value.data.ariaLabel;
    }
  }

  async redirectFromHeadline(): Promise<void> {
    await this.router.navigateByUrl(this.pageHeader.RedirectURL);
  }

  getPageLabels(): Observable<any> {
    return this.cms.getContent('oas-account-summary', 'Account Summary').pipe(
      map((data: any) => {
        if (!this.utils.isNullOrUndefined(data)) {
          this.seoS.setSeoTags(data.seo);
          return data;
        }
      }),
    );
  }

  dismissBannerAd(): void {
    this.showBannerAd = false;
    if (this.isBrowser) {
      this.storage.setSession(StorageEnum.AccountSummaryBannerDismissed, true);
    }
  }

  private setBannerAd(pageLabels: any): void {
    const bannerAd = pageLabels?.bannerAd?.value?.data as BannerAd | undefined;
    const isDismissed = this.isBrowser && this.storage.getSession(StorageEnum.AccountSummaryBannerDismissed) === true;

    this.bannerAd = bannerAd ?? null;
    this.showBannerAd = !isDismissed && this.isBannerInDateRange(bannerAd);
  }

  private isBannerInDateRange(bannerAd: BannerAd | undefined): bannerAd is BannerAd {
    if (!bannerAd) {
      return false;
    }

    const { startDate, endDate } = bannerAd;
    return Number.isFinite(startDate) && Number.isFinite(endDate) && Date.now() >= startDate && Date.now() <= endDate;
  }

  checkRateChangeEligibility(): void {
    if (
      (this.accountDetail.CustomerClass === 'RES' || this.accountDetail.CustomerClass === 'SMLCOM') &&
      !this.pageData.plan.planType.toUpperCase().includes('NYMEX') &&
      !this.pageData.plan.planType.toUpperCase().includes('COMPLEX') &&
      this.accountDetail.IsRenewalInProgress === false &&
      this.accountDetail.BillRate?.Type === RateType.Variable &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.SONPCompletedPastDue &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.SelectedForDisc &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.AtRiskDisc &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.StoppedBadDebt &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.StoppedPastDue &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.StoppedNoPastDue &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.ClosedButWithinSameSession &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.PendingStart &&
      this.accountDetail.LandLordAlertIndicator !== 'Y'
    ) {
      this.accountDetail.EligibileForRateChange = true;
      this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
      this.storage.setSession(StorageEnum.SelectedSA, this.accountDetail.ServiceAddresses[0]);
    }
  }

  checkRenewEligibility(): void {
    if (
      !this.utils.isNullOrUndefined(this.accountDetail.ServiceAddresses[0]) &&
      this.accountDetail.ServiceAddresses[0].SARenewalIndicator === 'Y' &&
      !this.pageData.plan.planType.toUpperCase().includes('NYMEX') &&
      !this.pageData.plan.planType.toUpperCase().includes('COMPLEX') &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.SONPCompletedPastDue &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.SelectedForDisc &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.StoppedBadDebt &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.StoppedPastDue &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.StoppedNoPastDue &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.ClosedButWithinSameSession &&
      this.accountDetail.HeadlineCode !== HeadlineEnum.PendingStart &&
      this.accountDetail.LandLordAlertIndicator !== 'Y'
    ) {
      this.accountDetail.EligibileForRenewal = true;
      this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
      this.storage.setSession(StorageEnum.SelectedSA, this.accountDetail.ServiceAddresses[0]);
    }
  }

  differenceInDates(account: AccountDetail): number {
    const todaysDate = format(new Date().toString(), 'MM/dd/yyyy');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const billDueDate = format(toDate(account.CurrentBalanceDueDate!).toString(), 'MM/dd/yyyy');

    return differenceInCalendarDays(todaysDate, billDueDate);
  }

  setPageData(): void {
    // pay plan Link
    this.pageData.payPlanURL = this.pageLabels.payPlanLink.value.data.url;
    this.pageData.payPlanLabel = 'Need more time to pay?';
    this.pageData.payPlanAriaLabel = this.pageData.payPlanLabel;

    // make a payment cta
    this.pageData.makeAPaymentLabel = this.pageLabels.makeAPaymentLink.value.data.linkText;
    this.pageData.makeAPaymentURL = this.pageLabels.makeAPaymentLink.value.data.url;
    this.pageData.payPlanAriaLabel = this.pageLabels.makeAPaymentLink.value.data.ariaLabel;

    // renew plan link
    this.pageData.renewPlanLabel = this.pageLabels.renewalLink.value.data.linkText;
    this.pageData.renewPlanURL = this.pageLabels.renewalLink.value.data.url;
    this.pageData.renewPlanAriaLabel = this.pageLabels.renewalLink.value.data.ariaLabel;

    // select plan link
    this.pageData.selectNewPlanLabel = 'Select A New Plan';
    this.pageData.selectNewPlanURL = this.pageLabels.selectNewRate.value.data.url;
    this.pageData.selectNewPlanAriaLabel = this.pageData.selectNewPlanLabel;

    // view bill link
    this.pageData.viewBillURL = this.accountDetail.Bills?.[0]?.URL;

    // cancel future payment link
    this.pageData.cancelFuturePaymentLabel = 'Cancel Scheduled Payment';
    this.pageData.cancelFuturePaymentURL = this.pageLabels.cancelFuturePaymentLink.value.data.url;
    this.pageData.cancelFuturePaymentAriaLabel = 'Go to cancel scheduled payment';

    // view all plans link
    this.pageData.viewPlansLabel = 'View Plans';
    this.pageData.viewPlansAriaLabel = 'Go to View All Plans';
    this.pageData.viewPlansURL = this.pageLabels.viewAllPlansLink.value.data.url;

    // not viewable bill text
    this.showFinalBillText = false;
    if (this.accountDetail.ServiceAddressCount > 0) {
      if (
        this.accountDetail.ServiceAddresses[0].SaStatusFlag === '40' &&
        !this.utils.isNullOrUndefined(this.accountDetail.FinalBillDate)
      ) {
        this.showFinalBillText = true;
      }
    }

    this.pageLabels.notViewableBillText = this.accountDetail.Bills?.[0].ExtractedDate
      ? this.pageLabels.notViewableBillText.replaceAll('{{ BillDueDate }}', this.formatBillDueDate())
      : this.pageLabels.viewBillPendingText;

    // set balance text
    this.pageLabels.noAutopayOrPayplanTexts.forEach((element: any) => {
      this.pageData[element.label] = element.textValue;
    });
    this.pageLabels.autopayWithNoPayplanTexts.forEach((element: any) => {
      this.pageData[element.label] = element.textValue;
    });
    this.pageData.BankAutoPayText = this.pageData.BankAutoPayText.replaceAll(
      '{{ AccountNumber }}',
      this.accountDetail.AutoPay?.AccountNumber,
    );

    if (
      this.accountDetail.AutoPay?.PaymentAccountType !== undefined &&
      this.accountDetail.AutoPay?.PaymentAccountType === PaymentAccountType.AmericanExpress
    ) {
      this.pageData.CardAutoPayText = this.pageData.CardAutoPayText.replaceAll(
        '{{ PaymentAccountType }}',
        'American Express',
      ).replaceAll('{{ AccountNumber }}', this.accountDetail.AutoPay?.AccountNumber);
    } else {
      this.pageData.CardAutoPayText = this.pageData.CardAutoPayText.replaceAll(
        '{{ PaymentAccountType }}',
        this.accountDetail.AutoPay?.PaymentAccountType,
      ).replaceAll('{{ AccountNumber }}', this.accountDetail.AutoPay?.AccountNumber);
    }

    this.pageData.CardAutoPayText = this.pageData.CardAutoPayText.replaceAll(
      '{{ PaymentAccountType }}',
      this.accountDetail.AutoPay?.PaymentAccountType,
    ).replaceAll('{{ AccountNumber }}', this.accountDetail.AutoPay?.AccountNumber);
    this.pageData.DigitalAutoPayText = this.pageData.DigitalAutoPayText.replaceAll(
      '{{ PaymentAccountType }}',
      this.accountDetail.AutoPay?.PaymentAccountType,
    );
    this.pageData.DueDateIsFurtherOutText = this.pageData.DueDateIsFurtherOutText.replaceAll(
      '{{ dueDate }}',
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      format(this.accountDetail.CurrentBalanceDueDate!, 'MMM dd'),
    );

    // tool tip text
    if (this.accountDetail.BillingRateExpirationDate && this.showExpirationDate) {
      this.pageData.expirationDate = format(
        this.accountDetail.BillingRateExpirationDate.toString().replaceAll('-', '/'),
        'MM/dd/yyyy',
      );
      // this.pageData.toolTipOpp = this.pageLabels.expirationDateToolTipText;
      this.pageData.toolTipRenew = this.pageLabels.renewPlanToolTip.replaceAll(
        '{{expirationDate}}',
        this.pageData.expirationDate,
      );
    }

    // change autopay link
    this.pageData.changeAutoPayUrl = '/autopay-cancel-change';
    this.pageData.changeAutoPayLabel = 'Change Auto-Pay';
    this.pageData.changeAutoPayAriaLabel = 'Going to change Auto-Pay';

    // Current Plan Data
    if (
      !this.utils.isNullOrUndefined(this.accountDetail.SaRateScheduleCode) &&
      !this.utils.isNullOrUndefined(this.accountDetail.CustomerClass)
    ) {
      this.pageData.plan = this.plan.getAllPlanData(
        this.accountDetail.SaRateScheduleCode,
        this.accountDetail.CustomerClass,
        this.accountDetail.BillRate?.Rate,
        this.accountDetail.BillRate?.Type,
      );
    }

    // set autopay message
    if (
      !this.utils.isNullOrUndefined(this.accountDetail.PastDueBalance) &&
      this.accountDetail.PastDueBalance !== undefined &&
      this.accountDetail.PastDueBalance > 0
    ) {
      this.pageData.autoPayMessage = this.pageData.AutopayPastDueText;
    } else if (
      !this.utils.isNullOrUndefined(this.accountDetail.CurrentBalance) &&
      this.accountDetail.CurrentBalance !== undefined &&
      (this.accountDetail.CurrentBalance <= 0 || this.accountDetail.CurrentBalance > 0)
    ) {
      if (this.accountDetail.CurrentBalance > 0) {
        if (
          !this.utils.isNullOrUndefined(this.dueDateDifference) &&
          this.dueDateDifference !== undefined &&
          this.dueDateDifference < 0
        ) {
          this.pageData.autoPayDueDateMessage = this.pageData.DueDateIsFurtherOutText;
        }
      } else {
        this.pageData.autoPayMessage = this.pageData.AccountBalanceIsCreditOrZero;
      }
    }

    this.setPlanDataToDisplay();
  }

  checkIsFourDayPrior(): boolean {
    const BillDueDate = this.accountDetail.Bills?.[0]?.ExtractedDate;
    const date = new Date();
    let showMessage: boolean = false;
    if (!this.utils.isNullOrUndefined(BillDueDate) && !this.utils.isNullOrUndefined(date) && BillDueDate) {
      const billAvailAfter = addDays(BillDueDate, 4);
      if (isAfter(date, billAvailAfter)) {
        showMessage = true;
      } else {
        showMessage = false;
      }
    }
    return showMessage;
  }

  formatBillDueDate(): any {
    const BillDueDate = this.accountDetail.Bills?.[0]?.ExtractedDate;
    if (!this.utils.isNullOrUndefined(BillDueDate) && BillDueDate) {
      return format(addDays(BillDueDate, 5), 'MMM d');
    }
  }

  setPlanDataToDisplay(): void {
    if (
      this.accountDetail.BillRate?.Type === RateType.Variable ||
      this.accountDetail.BillRate?.Type === RateType.Undefined
    ) {
      this.showExpirationDate = false;
      if (this.pageData.plan.planType !== 'Variable' && this.pageData.plan.planType !== 'Complex') {
        if (this.accountDetail.BillRate?.Type !== RateType.Undefined) {
          this.pageData.plan.planType = this.pageData.plan.planType.toUpperCase().includes('RATE')
            ? this.pageData.plan.planType
            : this.pageData.plan.planType.replaceAll(
                this.pageData.plan.planType,
                this.pageData.plan.planType + ' Rate',
              );
        }
      }
    } else {
      this.showExpirationDate = true;
      if (this.pageData.plan.planType !== 'Fixed' && this.pageData.plan.planType !== 'Complex') {
        if (this.pageData.plan.planType === 'OnePrice Plan') {
          this.pageData.plan.planType = this.pageData.plan.planType.toUpperCase().includes(this.oppTag)
            ? this.pageData.plan.planType
            : this.pageData.plan.planType.replaceAll(
                this.pageData.plan.planType,
                this.pageData.plan.planType + this.oppTag,
              );
        } else {
          if (!this.utils.isNullOrWhitespace(this.accountDetail.SaRateScheduleCode)) {
            this.pageData.plan.planType = this.pageData.plan.planType.toUpperCase().includes('RATE')
              ? this.pageData.plan.planType
              : this.pageData.plan.planType.replaceAll(
                  this.pageData.plan.planType,
                  this.pageData.plan.planType + ' Rate',
                );
          }
        }
      } else {
        this.pageData.plan.planType = this.pageData.plan.planType.toUpperCase().includes('RATE')
          ? this.pageData.plan.planType
          : this.pageData.plan.planType.replaceAll(this.pageData.plan.planType, this.pageData.plan.planType + ' Rate');
      }
    }
  }

  setFeatureTilesToShow(pageLabels: any): void {
    if (this.accountDetail.CustomerClass === 'RES' || this.accountDetail.CustomerClass === 'SMLCOM') {
      if (!this.accountDetail.PrimaryAccountHolder) {
        this.featureTiles = pageLabels.featureTiles.filter(
          (el: any) => !el.header.includes('Alerts') && (el.showTile === 'Always' || el.showTile === 'When No Alerts'),
        );
      } else {
        this.featureTiles = pageLabels.featureTiles.filter(
          (el: any) => el.header.includes('Wallet') || el.header.includes('Friend') || el.header.includes('Alerts'),
        );
      }
    } else {
      this.featureTiles = pageLabels.featureTiles.filter(
        (el: any) =>
          !el.header.includes('Friend') &&
          !el.header.includes('Alerts') &&
          (el.showTile === 'Always' || el.showTile === 'When No Alerts or Refer A Friend'),
      );
    }
  }
}
